var map = {
	"./akademiskahus.png": 65918,
	"./dbproperties.png": 16088,
	"./ica.png": 57529,
	"./logo_lc_p.png": 37915,
	"./sam-logo.png": 72905,
	"./zdb.png": 50156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70178;